import styled, {css, keyframes} from 'styled-components'
import {landGreen, lightGray} from '@modifi/colors'

const movePath = keyframes`
  0% {
    background-color: ${lightGray};
  }

  100% {
    background-color: ${landGreen};
  }
`

export const DeparturePort = styled.div<{$completed?: boolean}>`
  width: 15px;
  height: 15px;
  background-color: ${landGreen};
  border-radius: 2px;
  z-index: 2;
  ${({$completed}): any =>
    $completed
      ? css`
          animation: ${movePath} 3s ease 2s forwards;
        `
      : ''}
`

export const ArrivalPort = styled.div<{$completed?: boolean}>`
  width: 15px;
  height: 15px;
  background-color: ${lightGray};
  border-radius: 2px;
  margin-left: auto;
  z-index: 2;
  ${({$completed}): any =>
    $completed
      ? css`
          animation: ${movePath} 3s ease 2s forwards;
        `
      : ''}
`

export const Path = styled.div`
  position: absolute;
  z-index: 1;
  border-top: 2px dashed ${lightGray};
  width: 100%;
`

const ProgressWidthMixin = css<{$progress: number}>`
  width: ${({$progress}): string => `${$progress}%`};
  transition: width 2s ease 1s;
`

export const ProgressIndicator = styled.div<{$progress: number}>`
  position: relative;
  z-index: 9;
  height: 5px;
  background-color: ${landGreen};

  ${ProgressWidthMixin}
`

export const ShipIconWrapper = styled.div<{$progress: number}>`
  position: absolute;
  height: 0;
  min-width: 35px;
  max-width: calc(100% - 35px);
  ${ProgressWidthMixin}

  > svg {
    position: absolute;
    bottom: 3px;
    right: -20px;
  }
`

export const ShipLineWrapper = styled.div<{$isLoading?: boolean}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0 0;
  overflow: hidden;
  -webkit-backface-visibility: hidden;

  ${ProgressIndicator} {
    > svg {
      display: ${({$isLoading}): string => ($isLoading ? 'none' : 'block')};
    }
  }
`
